import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import Lottie from 'react-lottie';
import { Button, ButtonType } from '@lean-body/components/atoms';
import { Colors, MediaBreakPointUp } from '../styles';
import * as animationData from '../../lotties/1hi.json';
export const GoalMatchingAssessmentStartPage = ({ onClickNext }) => {
    const animationOptions = {
        loop: true,
        animationData: animationData,
    };
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.content) },
            React.createElement("img", { className: css(styles.logo), src: "/assets/images/logo-black.svg" }),
            React.createElement("div", { className: css(styles.character) },
                React.createElement(Lottie, { options: animationOptions, height: 160, width: 160 })),
            React.createElement("div", { className: css(styles.introductionText) },
                "\u3053\u3093\u306B\u3061\u306F\uFF01",
                React.createElement("br", null),
                "\u5065\u5EB7\u7BA1\u7406\u3092\u30B5\u30DD\u30FC\u30C8\u3059\u308BSabo\u3060\u3088\u266A"),
            React.createElement("div", { className: css(styles.introductionText, styles.introductionTextSecondary) }, "\u3042\u306A\u305F\u306B\u3074\u3063\u305F\u308A\u306E\u30D7\u30E9\u30F3\u3092\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3059\u308B\u305F\u3081\u306B\u3001\u8CEA\u554F\u306B\u7B54\u3048\u3066\u306D\u2728")),
        React.createElement("div", { className: css(styles.footerButtonBox) },
            React.createElement(Button, { className: css(styles.nextButton), onClick: onClickNext, buttonType: ButtonType.primary, dataTest: "matchingAssessmentNext", fullWidth: true, isRadius: true }, "\u306F\u3058\u3081\u308B"))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100%',
        padding: '96px 24px 120px',
        backgroundColor: Colors.White,
        backgroundImage: 'url(/assets/images/goal_matching_assessments/introduction_pattern.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: 'contain',
        justifyContent: 'center',
        [MediaBreakPointUp.MD]: {
            padding: '120px 24px 160px',
            backgroundSize: 'contain',
        },
        [MediaBreakPointUp.XL]: {
            paddingBottom: 180,
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 360,
        margin: '0 auto',
    },
    logo: {
        width: 230,
        marginBottom: 32,
    },
    character: {
        width: 193,
        height: 193,
    },
    introductionText: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '170%',
        letterSpacing: 0.56,
        maxWidth: 320,
    },
    introductionTextSecondary: {
        marginTop: 8,
    },
    introductionImg: {
        width: 311,
    },
    footerButtonBox: {
        position: 'fixed',
        textAlign: 'center',
        bottom: 16,
        width: 'calc(100% - 32px)',
        [MediaBreakPointUp.MD]: {
            width: 343,
            margin: '0 auto',
        },
    },
    nextButton: {
        fontSize: 16,
        height: 48,
    },
});
